export default "__VITE_ASSET__DOZk3vrh__"